import { Grid, useTheme } from '@mui/material';
import DynamicGridItem from './DynamicGridItem';

interface ProductConfigurationViewProps {
  attributes: Record<string, unknown> | null | undefined;
  title: string | undefined;
}

const ProductConfigurationView = (props: ProductConfigurationViewProps) => {
  const { attributes, title } = props;
  const attributeKeys = attributes ? Object.keys(attributes) : [];
  const theme = useTheme();

  const getLength = (keys: string[]) => {
    const filteredKeys = keys.filter(
      (attribute) => attribute !== 'serviceRole' && attributes && typeof attributes[attribute] === 'string',
    );
    return filteredKeys.length - 1;
  };

  return (
    <Grid data-testid="product-configuration-view" container sx={{ paddingBottom: theme.spacing(1) }}>
      {attributes &&
        attributeKeys.map(
          (attribute, index) =>
            attribute !== 'serviceRole' && (
              <DynamicGridItem
                data-testid={`product-configuration-view-${attribute}`}
                key={index}
                index={index}
                length={getLength(attributeKeys)}
                item={attributes[attribute] as string | number | Record<string, unknown> | null | undefined}
                attribute={attribute}
                title={title}
              />
            ),
        )}
      {attributes?.length === 0 && (
        <Grid item xs={12}>
          {`No configuration found, please press "Edit product" button in order to configure product.`}
        </Grid>
      )}
    </Grid>
  );
};

export default ProductConfigurationView;
